var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5832 4.78164H5.99984C5.51361 4.78164 5.04729 4.9748 4.70347 5.31861C4.35966 5.66243 4.1665 6.12875 4.1665 6.61498V16.6983C4.1665 17.1845 4.35966 17.6509 4.70347 17.9947C5.04729 18.3385 5.51361 18.5316 5.99984 18.5316H16.0832C16.5694 18.5316 17.0357 18.3385 17.3795 17.9947C17.7233 17.6509 17.9165 17.1845 17.9165 16.6983V12.115M16.6203 3.48548C16.7895 3.31037 16.9918 3.17071 17.2154 3.07462C17.4391 2.97854 17.6797 2.92797 17.9231 2.92585C18.1665 2.92374 18.4079 2.97012 18.6333 3.0623C18.8586 3.15448 19.0633 3.29062 19.2354 3.46275C19.4075 3.63489 19.5437 3.83958 19.6358 4.06489C19.728 4.2902 19.7744 4.53162 19.7723 4.77505C19.7702 5.01847 19.7196 5.25904 19.6235 5.48272C19.5274 5.70639 19.3878 5.90869 19.2127 6.07781L11.3422 13.9483H8.74984V11.356L16.6203 3.48548Z",
    stroke: "#1462B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.3c1f3414ae57b106e925a4660e1480af.svg";
export { ForwardRef as ReactComponent };